import authorAvt1 from '../assets/images/authorAvt1.jpeg'
import podcast1 from '../assets/audios/letme.mp3'

const initState = {
   podcasts: [
      {
         id: 1,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'This Florida City Is the Best Place to Retire in the U.S., According to Experts',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise'],
      },
      {
         id: 2,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'You Can Have Puppies and Prosecco Delivered to Your Room at This Denver Hotel',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'diving'],
      },
      {
         id: 3,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Another Tourist Was Attacked by a Bison in a National Park This Week',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'diving'],
      },
      {
         id: 4,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'How America Eats: Bringing Culinary Travel Inspiration Home',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['cruise'],
      },
      {
         id: 5,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Please Don’t Treat National Parks Like a Garbage Can',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['cruise'],
      },
      {
         id: 6,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: '67 Percent of People Don’t Use Enough Sunscreen, U.K. Study Says',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['cruise'],
      },
      {
         id: 7,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'You Can Have Puppies and Prosecco Delivered to Your Room at This Denver Hotel',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['diving'],
      },
      {
         id: 8,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'This Florida City Is the Best Place to Retire in the U.S., According to Experts',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure'],
      },
      {
         id: 9,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Another Tourist Was Attacked by a Bison in a National Park This Week',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise', 'diving'],
      },

      // featured podcasts
      {
         id: 10,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'You don’t have to be rich to travel well around the world',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 24, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise', 'diving'],
      },
      {
         id: 11,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: '17 Unconventional Travel Hacks You Need for Next Trip',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise', 'diving'],
      },
      {
         id: 12,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Vacation Photos: Palm Springs and San Francisco',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 23, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise', 'diving'],
      },
      {
         id: 13,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'A Wellness Trip is Exactly What You Need',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 22, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise', 'diving'],
      },
      {
         id: 14,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'You don’t have to be rich to travel well around the world',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 21, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise', 'diving'],
      },
      {
         id: 15,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Vacation Photos: Palm Springs and San Francisco',
         desc: 'Lorem ipsum dolor sit amet, consectetur loerm adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore…',
         date: 'November 20, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['adventure', 'cruise', 'diving'],
      },

      // popular podcasts
      {
         id: 16,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: '17 Unconventional Travel Hacks You Need for Your Next Trip',
         desc: 'Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit.',
         date: 'November 20, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['wave', 'wave', 'wave'],
      },
      {
         id: 17,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Keeping travelling memories close on my next adventure',
         desc: 'Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit.',
         date: 'November 20, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['wave', 'wave', 'wave'],
      },
      {
         id: 18,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'Vacation Photos: Palm Springs and San Francisco',
         desc: 'Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit.',
         date: 'November 20, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['wave', 'wave', 'wave'],
      },
      {
         id: 19,
         audio: podcast1,
         author: 'Scott Jackson',
         avatar: authorAvt1,
         title: 'You don’t have to be rich to travel well around the world',
         desc: 'Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit.',
         date: 'November 20, 2020',
         createdAt: 1686735683583,
         comments: 2,
         likes: 0,
         categories: ['wave', 'wave', 'wave'],
      },
   ],

   latestPodcasts: [1, 2, 3],

   podcastFeeds: [1, 2, 3, 4, 5, 6, 7, 8, 9],

   featuredPodcasts: [10, 11, 12, 13, 14, 15],

   popularPodcasts: [16, 17, 18, 19],
}

function podcastReducer(state = initState, action) {
   switch (action.type) {
      case '':
         return state

      default:
         return state
   }
}

export default podcastReducer
